'use client'

import { type FC } from 'react'
import { useIntl } from 'react-intl'

import { SeoHeadTitleMetas } from '../../../../seo'

export const SearchPageSeoHeadTags: FC = () => {
  const intl = useIntl()
  const titleContent = intl.formatMessage({
    id: 'metaTag.searchResults',
  })

  return (
    <>
      <SeoHeadTitleMetas title={titleContent} />
      <meta content="noindex, nofollow" name="robots" />
    </>
  )
}
